@if (numberOfTrees > 0 || client.isCms) {
<div class="_banner flex flex-justify-center flex-middle p-a-2 m-t">
    <div class="ratio-2-1 _logo">
        @if( content?.logo ) {
        <img [image]="content.logo"
             class="fill">
        }
    </div>
    @if (copy) {
    <p class="m-l-3 p2 col-w">{{copy}}</p>
    }
</div>
}